<template>
    <modal @close="$emit('close')">
      <div class="text-center">
        <ticket-info :ticket="ticket" />
  
        <div class="mb-4">
          <p class="text-muted mb-2">Scan this QR code</p>
          <div class="d-flex justify-content-center">
            <div ref="qrcodeContainer"></div>
          </div>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  import QRCode from 'qrcodejs2';
  import Modal from './Modal.vue';
  import TicketInfo from './TicketInfo.vue';
  
  export default {
    name: 'TicketDetails',
    components: {
      Modal,
      TicketInfo
    },
    props: {
      ticket: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        qrcode: null
      }
    },
    mounted() {
      this.generateQRCode();
    },
    beforeUnmount() {
      // Clean up by removing the QR code element
      if (this.$refs.qrcodeContainer) {
        this.$refs.qrcodeContainer.innerHTML = '';
      }
    },
    methods: {
      generateQRCode() {
        // Clear any existing QR code
        if (this.$refs.qrcodeContainer) {
          this.$refs.qrcodeContainer.innerHTML = '';
        }
  
        // Generate QR code data
        const qrData = JSON.stringify({
          ticketId: this.ticket.id,
          timestamp: Date.now()
        });
  
        // Create new QR code
        this.qrcode = new QRCode(this.$refs.qrcodeContainer, {
          text: qrData,
          width: 250,
          height: 250,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      }
    }
  }
  </script>